import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import EditIcon from '@wix/da-ds/pkg/Icons/24x24/Edit';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
export const EditButton = ({ deviation , onClick  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: t('actionbar.edit')
    }, /*#__PURE__*/ React.createElement(ActionBarEditButton, {
        onClick: ()=>{
            onClick({
                deviation
            });
        },
        biData: {
            evid: BiEventType.DEVIATION_EDIT_CLICK,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        }
    }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
        icon: EditIcon
    })));
};
EditButton.displayName = 'EditButton';
export default EditButton;
